import React from 'react';
import { IIconProps } from './utils';

export const Reading = ({
  fill = 'currentColor', height = 39, width = 39, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 39 39"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20.0121 14.3406C20.0121 11.9919 21.9161 10.0879 24.2648 10.0879H31.3526C32.1355 10.0879 32.7702 10.7226 32.7702 11.5055V28.5163C32.7702 29.2992 32.1355 29.9339 31.3526 29.9339H29.9351H20.0121M20.0121 14.3406C20.0121 11.9919 18.108 10.0879 15.7593 10.0879H8.67148C7.88857 10.0879 7.25391 10.7226 7.25391 11.5055V14.3406M20.0121 14.3406V29.9339M20.0121 29.9339H8.67148C7.88857 29.9339 7.25391 29.2992 7.25391 28.5163V20.0109"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.83514"
    />
  </svg>
);
